import { render } from "./SpeicherDiagramm.vue?vue&type=template&id=2be2206a&scoped=true&ts=true"
import script from "./SpeicherDiagramm.vue?vue&type=script&lang=ts"
export * from "./SpeicherDiagramm.vue?vue&type=script&lang=ts"

import "./SpeicherDiagramm.vue?vue&type=style&index=0&id=2be2206a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be2206a"]])

export default __exports__